import { SlideInModal } from '@/src/common/components/SlideInModal'
import { SquareCard } from '@/src/common/components/SquareCard'
import { Button } from '@/src/common/components/Button'
import { Link, router } from 'expo-router'
import { StyleSheet, View, Text } from 'react-native'
import BottomSheet from '@gorhom/bottom-sheet'
import { RefObject } from 'react'
import { MesaMonogram } from '@/src/assets/icons/MesaMonogram'
import { MesaCardImage } from '@/src/common/modules/CardSection'
import { mesaColorNames, typography } from '@/src/common/theme'
import { useSourcePartnerName } from '@/src/common/hooks/useSourcePartnerName'
import { useMortgageModuleDesign } from '../../mortgage/statsig/store/useMortgageModuleDesign'

export const CardBenefitsComponentsNonMesaMemberModal = ({
  bottomSheetRef,
}: {
  bottomSheetRef: RefObject<BottomSheet | null>
}) => {
  const { sourcePartnerName } = useSourcePartnerName()
  const moduleDesign = useMortgageModuleDesign(sourcePartnerName)
  const { card_name } = moduleDesign
  const mesaCardName = card_name || 'The Mesa Homeowners Card'

  return (
    <SlideInModal ref={bottomSheetRef} title="Mesa Card Exclusive Benefit">
      <View style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <SquareCard
          background={false}
          style={{ overflow: 'hidden', alignSelf: 'stretch', padding: 0 }}
        >
          <MesaMonogram style={StyleSheet.absoluteFill} />
          <MesaCardImage style={{ margin: 'auto' }} />
        </SquareCard>
        <View style={{ paddingHorizontal: 16, gap: 10 }}>
          <Text
            style={[
              { color: mesaColorNames['Greyscale/900 #152438'], textAlign: 'center' },
              typography['heading/heading3'],
            ]}
          >
            {mesaCardName}
          </Text>
        </View>
        <View style={{ paddingHorizontal: 16, gap: 10 }}>
          <Text
            style={[
              { color: mesaColorNames['Greyscale/900 #152438'], textAlign: 'center' },
              typography.S,
            ]}
          >
            This benefit is only available for current Mesa Homeowners Card Members. Earn Mesa
            Points on home and everyday spend including home improvement, decor, gas, grocery, and
            more!{' '}
            <Link href="https://www.mesamember.com/legal/mesa-homeowners-card-benefit-terms-of-use">
              <Text
                style={[
                  { color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] },
                  typography.S,
                ]}
              >
                Terms Apply
              </Text>
            </Link>
          </Text>
        </View>
        <Button
          onPress={() => {
            router.dismissTo('/main/card-benefits')
            router.push('/main/card/cardBenefits')
            bottomSheetRef.current?.close()
          }}
          title="Learn More"
        />
        <Button
          testID="close-modal-button-benefits"
          buttonStyle={{ backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'] }}
          onPress={() => bottomSheetRef.current?.close()}
        >
          <Text
            style={{
              color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
              ...typography['label/md-bold'],
            }}
          >
            Back
          </Text>
        </Button>
      </View>
    </SlideInModal>
  )
}
